<template>
    <v-row>
        <v-col>            
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>                                                                                    
                            <div class="d-flex justify-space-between" style="width: 100%;">
                                <div class="d-flex justify-space-between px-3">   
                                    <!--<img class="ma-1- mx-0"  src="/icon-small.jpg" height="36" />-->
                                    <h5 class="ma-1 ml-4 mt-6" >Network Statistics Report</h5> 
                                </div> 
                                <v-select class="ml-4"   label="Select Network" v-model="code" :items="networkOptions"></v-select>
                                <div class="d-flex flex"></div>
                                <div style="width: 350px;"> 
                                    <v-menu                                    
                                        ref="calcDatepicker"
                                        v-model="calculationDatepickerFrom"
                                        :close-on-content-click="false"
                                        
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{on, attrs}">
                                            <v-text-field
                                            class="ma-4 mb-0 d-flex flex"
                                                label='From'
                                                dense
                                                outlined
                                                v-model="calculationDateFrom"                                              
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                hide-details    
                                                :clearable="true"                                                       
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="calculationDateFrom" :max="datepickerMaxLimit" scrollable>                    
                                        </v-date-picker>
                                    </v-menu>
                                </div>     
                                <div style="width: 350px;"> 

                                    <v-menu                                    
                                    ref="calcDatepicker"
                                    v-model="calculationDatepickerTo"
                                    :close-on-content-click="false"
                                    
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{on, attrs}">
                                        <v-text-field
                                        class="ma-4 mb-0 d-flex flex"                                            
                                            label='To'
                                            dense
                                            outlined
                                            v-model="calculationDateTo"                                              
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            hide-details    
                                            :clearable="true"                                                       
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="calculationDateTo" :max="datepickerMaxLimit" scrollable>                    
                                    </v-date-picker>
                                </v-menu>
                                </div>                           
                                
                                <v-btn class="maz-4 mt-4" dark color="primary" @click="getData" :loading="progressStatsLoading">
                                        <v-icon>mdi-reload</v-icon>
                                        Reload
                                </v-btn>
                            </div>
                        </v-card-title>                                        
                        <v-progress-linear
                            :active="progressStatsLoading"
                            :indeterminate="progressStatsLoading"
                            absolute
                            bottom
                            color="deep-purple accent-4"
                        />
                    </base-card>
                    <!--<div class="d-block text-center mt-8"> 
                        <v-progress-circular
                        v-if="progressStatsLoading"
                        indeterminate
                        color="primary"
                        ></v-progress-circular>
                        <div v-else >no cache entries found </div>
                    </div>-->
                </v-col>
            </v-row>

            <v-row>
                <v-col :cols="4">                    
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>    
                                <div class="body-2" style="color: white">
                                    {{netcode}}
                                </div>                                                            
                                <v-list-item-title class="headline mb-1 font-weight-bold">
                                    {{ title }}                                                            
                                </v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info ml-10-">
                                            <span>{{description}}</span>
                                            <!--<span>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<v-chip                                                                                                          
                                                    class="mr-4 rounded-pill"    
                                                    small
                                                    color="success"                            
                                                    label                                            
                                                    text-color="white"
                                                >
                                                    
                                                    {{"status"}}
                                                </v-chip>
                                            </span>  -->
                                        </span>
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content> 
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col 
                    :cols="2" 
                    @click="visitAdpointsManagement"     
                    style="cursor: pointer"                
                >                                        
                    <card-dashboard title="No of AdPoints" :primaryvalue="total_adpoints" :isLink="true"></card-dashboard>
                </v-col>
                <v-col :cols="2">                    
                    <card-dashboard title="Total Capacity" :primaryvalue="total_capacity" ></card-dashboard>
                </v-col>
                <!--<v-col v-if="budgetAmount" :cols="headerCols">
                    <card-dashboard title="" :primaryvalue="budgetAmount" unit="€" secondaryvalue="Budget" ></card-dashboard>
                </v-col>-->
                <!-- <v-col cols="2">
                    <card-dashboard title="Goal" :primaryvalue="goalAmount" :unit="goalUnit == 'impression' ? 'impr.' : goalUnit + 's'" ></card-dashboard>
                </v-col>
                <v-col cols="2">
                    <card-dashboard title="Type" :primaryvalue="budgetType" ></card-dashboard>

                </v-col> -->
            </v-row>
            <hr style="opacity: 0.2">
             <v-row v-for="o in organizations" :key="o.org_id"> 
                <v-col cols="2">
                    <card-dashboard :title="o.org_name + ' Capacity Allocation'" :primaryvalue="o.capacity_max_limit" :secondaryvaluebig="o.allocation_pct + '%'" ></card-dashboard>
                </v-col>
                <v-col cols="2">
                    <card-dashboard title="Impressions Allocated" :primaryvalue="o.impressions_allocated" ></card-dashboard>
                </v-col>
                <v-col cols="2">
                    <card-dashboard title="Monetized Impressions" :primaryvalue="o.monetized_impressions" ></card-dashboard>
                </v-col>
                <v-col cols="2">
                    <card-dashboard title="Non-Monetized Impressions" :primaryvalue="o.non_monetized_impressions" ></card-dashboard>
                </v-col>
                <v-col cols="2">
                    <card-dashboard title="Remaining Impressions Avail." :primaryvalue="o.remaining_impressions_available" ></card-dashboard>
                </v-col>
                <v-col cols="2">

                </v-col>
            </v-row> 
            <hr style="opacity: 0.2">
            <v-row> 
                <v-col cols="2">
                    <card-dashboard title="Total No of Campaigns" :primaryvalue="total_campaigns" ></card-dashboard>
                </v-col>
                <v-col cols="2">
                    <card-dashboard title="Total Campaigns Active" :primaryvalue="total_campaigns_active" ></card-dashboard>
                </v-col>
                <v-col cols="2">
                    
                </v-col>
                <v-col cols="2">
                    
                </v-col>
                <v-col cols="2">
                    
                </v-col>
                <v-col cols="2">

                </v-col>
            </v-row>
            <hr style="opacity: 0.2">
            <v-row>
                <v-col cols="12">                                        
                    <v-select class="ml-4" style="max-width: 200px;" label="Filter Campaigns" v-model="campaignFilter" :items="campaignFilterOptions"></v-select>
                    <v-simple-table  style="display: block; width: 100%">
                        <thead>
                            <tr>
                                <th>Campaign Name</th>
                                <th>Brand</th>
                                <th>Owner</th>
                                <th>Monetized</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Impressions</th>
                                <th>Clicks</th>
                                <th>&nbsp;</th>
                                <!--<th>Events</th>-->
                            </tr>
                        </thead>
                        <tbody class="tinytablelistt">                                        
                                    <tr v-for="(c, idx) in campaigns_filtered" :key="idx">
                                        <td class="nobottomborder">{{ c.name || '-' }}</td>
                                        <td class="nobottomborder">{{ c.brand || '-' }}</td>
                                        <td class="nobottomborder">{{ c.owner || '-' }}</td>                                        
                                        <td v-if="c.monetized == 'YES' || c.monetized == 'yes'" class="nobottomborder"><v-icon color="success">mdi-check-circle</v-icon></td>
                                        <td v-else-if="c.monetized == 'NO' || c.monetized == 'no'" class="nobottomborder"><v-icon color="primary">mdi-cancel</v-icon></td>
                                        <td v-else class="nobottomborder">{{ c.monetized || '-' }}</td>
                                        <td class="nobottomborder">{{ c.from ? c.from.substring(0,10) : '-' }}</td>
                                        <td class="nobottomborder">{{ c.to ? c.to.substring(0,10) : '-' }}</td>
                                        <td class="nobottomborder">{{ c.impressions_clicks_plays || '-' }}</td>                                        
                                        <td class="nobottomborder">{{ c.clicks || '-' }}</td>
                                        <td class="nobottomborder">
                                            <v-btn                                        
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                :to="'/mng/reports/overview/' + c.id"
                                            >
                                                <v-icon>mdi-chart-bar</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>                                                                    
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-snackbar
                v-model="mysnackbar"
                :timeout="4000"
                bottom
                tile
                color="red"            
                >
                -
            </v-snackbar>
        </v-col>
    </v-row>
</template>

<script>
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";
import moment from "moment";
import AdvancedGridFiltersList from "@/components/core/AdvancedGridFiltersList";
import {GGanttChart, GGanttRow} from 'vue-ganttastic';
import { GChart } from 'vue-google-charts/legacy';
import CardDashboard from "@/components/campaigns/CardDashboard";
import ReportRuleComponent from "@/components/campaigns/campaign-report-rule-component";
import {parseDate, formatDate} from '@/core/date-utils.js';
import { integerFormatting } from '@/core/number-utils.js'
// import Gantt from '@salamander.be/vue-gantt/src/components/gantt.vue';
import {
    gradientLineChart,
    salesByCountries,
    visitorsAnalytic
} from '@/data/sales2';
import {
  analyticOne,
  analyticTwo,
  analyticThree,
  analyticFour,
  analyticFive,
} from "@/data/analytic2";

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Adpoints Management'
    },    
    components: {
        "advanced-grid-filters-list": AdvancedGridFiltersList    ,
        GGanttChart,
        GGanttRow,
        GChart,
        CardDashboard,
        "report-rule-component": ReportRuleComponent
       // Gantt  
    },
    data() {
        return {                        

            mysnackbar: false,    
            mysnackbar_msg: "",       
            progressStatsLoading: true,
            code: null,
            networkOptions: [],

            calculationDateFrom: null,
            calculationDatepickerFrom: null,
            calculationDateTo: null,
            calculationDatepickerTo: null,
            datepickerMaxLimit: null,


            netcode: null,
            title: null,
            description: null,
            total_adpoints: null,
            total_capacity: null,
            //remaining_impressions_avail_total: null,
            total_campaigns: null,
            total_campaigns_active: null,

            organizations: [
                {
                    org_name: null,
                    allocation_pct: null,
                    capacity_max_limit: null,
                    impressions_allocated: null,
                    monetized_impressions: null,
                    non_monetized_impressions: null,
                    remaining_impressions_available: null
                }
            ],

            campaigns: [
                {
                    name: null,
                    brand: null,
                    owner: null,
                    monetized: null,
                    from: null,
                    to: null,
                    impressions_clicks_plays: null,
                    clicks: null,
                    plays: null
                }                
            ],


            campaignFilter: "All", //"Monetized", "Non-Monetized"
            campaignFilterOptions: [
                {value: "All", text: "Show All"},
                {value: "Monetized", text: "Monetized"},
                {value: "Non-Monetized", text: "Non-Monetized"},
            ]
            
        }
    },
    filters: {

    },
    watch: {
      
    },
    computed: {
        campaigns_filtered() {
            const filt = this.campaignFilter;
            let rslt = [];

            if(this.campaigns == null || !Array.isArray(this.campaigns)) {
                rslt = [];
            }
            if(filt=="All") {
                rslt = this.campaigns;
            }
            else if (filt=="Monetized") {
                rslt = this.campaigns.filter(c=>c.monetized=="YES");
            }            
            else {
                rslt = this.campaigns.filter(c=>c.monetized=="NO");
            }
            return rslt;
        }
    },
    methods: {
        visitAdpointsManagement() {
            this.$router.push({
                path: '/mng/adpoints/management',
                query: { network: this.code }
            });
        },
        async exportDocument(selectedCampaign) {
            
            await new Promise(resolve => setTimeout(resolve, 12000));
            this.progressStatsLoading = false;
            //this.mysnackbar=true;
            this.progressStatsLoading=false;
        },

        async getData() {
            this.progressStatsLoading=true;
            try {
                const rsp = await srvApi.post(PATH.REPORTING_NETWORK + '/' + this.code, {
                    startDate: this.calculationDateFrom,
                    endDate: this.calculationDateTo
                });
                this.title = rsp.data.title;
                this.description = rsp.data.description;
                this.netcode = rsp.data.netcode;
                this.total_adpoints = rsp.data.total_adpoints;
                this.total_capacity = rsp.data.total_capacity;
                this.total_campaigns = rsp.data.total_campaigns;
                this.total_campaigns_active = rsp.data.total_campaigns_active;

                this.organizations.splice(0, this.organizations.length);
                this.organizations.push(...rsp.data.organizations);

                this.campaigns.splice(0, this.campaigns.length);
                this.campaigns.push(...rsp.data.campaigns);
            } catch (error) {
                this.mysnackbar_msg= "Error: " + (error.message || error.msg || "Server Error");
                this.mysnackbar=true;
            }
            finally {
                this.progressStatsLoading=false;
            }
            
        }

        
    },
    async created() {
        let today = new Date();
        let sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        let oneDayAgo = new Date();
        oneDayAgo.setDate(oneDayAgo.getDate() - 1);
        let thirtyDaysAfter = new Date();
        thirtyDaysAfter.setDate(thirtyDaysAfter.getDate() + 30);
        this.calculationDateFrom = sevenDaysAgo.toISOString().substring(0,10);
        this.calculationDateTo = oneDayAgo.toISOString().substring(0,10);
        this.datepickerMaxLimit = thirtyDaysAfter.toISOString().substring(0,10);              
    },
    async mounted() {        
        //await new Promise(resolve => setTimeout(resolve, 12000));
        const basicData = await srvApi.get(PATH.NETWORK_ASOPTIONS);
        this.networkOptions.push(...basicData.data.filter(o=>o.extra.type != 'static').map(i=>({value: i.extra.code, text: i.text})));

        if(this.$route.params.code) {
            this.code = this.$route.params.code;
        }      
        else {
            if(this.networkOptions.length>0) {
                this.code = this.networkOptions[0].value
            }
        }  
        await this.getData();
        
        //this.mysnackbar=true;
        this.progressStatsLoading=false;

        /*
        let ff = this.filterfields.find(i=>i.selectvalue === "brand");        
        if(ff) {
            const rsp = await api.brand.getAll();            
            ff.listItems = rsp.data.map(i=> {return {selectvalue: i.code, selecttext: i.title}});
        }
        */
    }
}
</script>
<style lang="scss">
.apexcharts-toolbar {
    //background-color: red;
    margin-top: -10px;
}
</style>

<style lang="scss" scoped>
.metrics-grid {
    //background-color: red;
    //margin-top: -10px;
    display: grid;
    grid-template-columns: repeat(8, 1fs [col-start]);
    grid-template-rows: [row1-top] 1fs [row2-bottom] 1fs;
    column-gap: 24px;
    row-gap: 12px;
}

.metrics-griditem {
    //background-color: red;
    //margin-top: -10px;
    
    //border: 2px red solid;
}

.v-card .v-list-item {
    // color: #304156 !important;
}

</style>
